export default __webpack_public_path__ + "static/media/favicon.08a58593.ico";